import { NgModule } from '@angular/core';
import { UserTaskListModule } from './user-task-list/user-task-list.module';
import { UserTaskPreviewModule } from './user-task-preview/user-task-preview.module';
import { UserTaskService } from '../services/user-task.service/user-task.service';

@NgModule({
  imports: [UserTaskListModule, UserTaskPreviewModule],
  exports: [UserTaskListModule, UserTaskPreviewModule],
  providers: [UserTaskService],
})
export class UserTasksModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-tasks.module.ts